import type { ComponentProps } from "react";
import { PHONE_PREFIX, formatNational, nationalDigits } from "~/lib/phone";
import { cn } from "~/lib/utils";

export function PhoneInput({
  value,
  onChange,
  invalid,
  className,
  ...props
}: Omit<ComponentProps<"input">, "value" | "onChange" | "type"> & {
  value: string;
  onChange: (digits: string) => void;
  invalid?: boolean;
}) {
  return (
    <div
      className={cn(
        "border-hairline bg-surface flex h-12 items-center rounded-lg border transition-colors",
        "focus-within:border-ring focus-within:ring-ring/40 focus-within:ring-2",
        invalid && "border-destructive ring-destructive/30 ring-2",
        className,
      )}
    >
      <span className="border-hairline text-muted-foreground tabular flex h-full items-center border-r px-3.5 text-[16px]" aria-hidden>
        {PHONE_PREFIX}
      </span>
      <input
        type="tel"
        inputMode="numeric"
        autoComplete="tel-national"
        placeholder="712 345 678"
        value={formatNational(value)}
        onChange={(e) => onChange(nationalDigits(e.target.value))}
        aria-invalid={invalid || undefined}
        className="placeholder:text-text-faint tabular h-full min-w-0 flex-1 bg-transparent px-3.5 text-[16px] outline-none"
        {...props}
      />
    </div>
  );
}
